import $ from 'jquery';
window.$ = window.jQuery = $;


import 'datatables.net/js/jquery.dataTables';
import 'jquery-ui/ui/widgets/autocomplete.js';
// import 'js-datepicker/dist/datepicker.min.js';

import './bootstrap';

import { createApp, defineAsyncComponent } from 'vue';

import Clock from './components/Clock';

import Employee from './components/Employee';
import EmployeeList from './components/EmployeeList';
import AutomaticStamps from './components/AutomaticStamps';

import TimekeepingStatus from './components/TimekeepingStatus';
import StampTable from './components/StampTable';
import EmployeeStamps from './components/EmployeeStamps';

// import ShiftPlan from './components/ShiftPlan';
// import ShiftPlanLine from './components/ShiftPlanLine';
import ProjectEmployees from './components/ProjectEmployees';

import EmployerRates from './components/EmployerRates';
import EmployerRateBonuses from './components/EmployerRateBonuses';
import EmployerRateBonusProfiles from './components/EmployerRateBonusProfiles';
import EmployeeSettingProfiles from './components/EmployeeSettingProfiles';
import EmployeeSettingProfilesButton from './components/EmployeeSettingProfilesButton';
import EmployeeContracts from './components/EmployeeContracts';
import EmployeeCalendar from './components/EmployeeCalendar';
import EmployeeCalendarDay from './components/EmployeeCalendarDay';
import EmployeeeSubstitutionModal from './components/EmployeeeSubstitutionModal.vue';

import VacationCalendar from './components/VacationCalendar';
import AddAbsence from './components/AddAbsence';
import EditAbsenceButton from './components/EditAbsenceButton';
import AdjustFlextime from './components/AdjustFlextime';

import ChangeEmployee from './components/ChangeEmployee';
import ChangeEmployeeInline from './components/ChangeEmployeeInline';
import EmployeeInfo from './components/EmployeeInfo';
import EmployeesExportlist from './components/EmployeeExportlist.vue';
import EmployeeSicknessList from './components/EmployeeSicknessList';

import QualificationMatrix from './components/QualificationMatrix';
import QualificationCell from './components/QualificationCell';

import ExperienceMatrix from './components/ExperienceMatrix';
import ExperienceCell from './components/ExperienceCell';

import Project from './components/Project';
import ProjectQualifications from './components/ProjectQualifications';
import SubprojectProjects from './components/SubprojectProjects';
import WorktimeAlarms from './components/WorktimeAlarms';
import ClientBudgets from './components/ClientBudgets';

import MyLogin from './components/MyLogin';
import MyVacation from './components/MyVacation';
import MyVacationList from './components/MyVacationList';
import MyVacationYear from './components/MyVacationYear';
import MyVacationYearAdditionalInfos from './components/MyVacationYearAdditionalInfos.vue';
import VacationRequest from './components/VacationRequest';
import VacationConfirmation from './components/VacationConfirmation';

import JournalSwitches from './components/JournalSwitches';

import MultiselectLocations from './components/MultiselectLocations';
import MultiselectEmployers from './components/MultiselectEmployers';
import MultiselectTeams from './components/MultiselectTeams';
import MultiselectLocations2 from './components/MultiselectLocations2';
import SingleSelectEmployees from './components/SingleSelectEmployees.vue';

import Dashboard from './components/dashboard/Dashboard';
import Histroy from './components/History';
import VacationHistory from './components/VacationHistory';

import OimAppointmentsList from './components/OimAppointments';
import OimAppointmentResubmissionModal from './components/OimAppointmentAddResubmissionModal'
import ExternalTimesListWithoutOut from './components/ExternalTimesWithoutOut';
import ExternalTimesListMissing from './components/ExternalTimesMissing';
import Reviews from './components/Reviews';
import ProjectsOpen from './components/ProjectsOpen';
import VacationOpenRequests from './components/VacationOpenRequests.vue';
import ExpiredQualifications from './components/QualificationsExpired.vue';
import Notifications from './components/Notifications.vue';
import EmployeeVacationModal from './components/EmployeeVacationModal.vue';
import EmployeeDaysOver10h from './components/EmployeeDaysOver10h.vue';

import ManualTimeTracking from './components/ManualTimeTracking';
import ManualTimeTrackingHead from './components/ManualTimeTrackingHead';

import MultiSelectCostcentre from './components/MultiSelectCostcentre';

import ViewAll from './components/ViewAll';
import CalculationStatus from './components/CalculationStatus';

import WagetypeWorktype from './components/WagetypeWorktype';

import OpenModalButton from './components/OpenModalButton.vue';
import IframeModal from './components/IframeModal.vue';

import CreateSingleTrainingButton from './components/CreateSingleTrainingButton.vue';

import MyWebsiteDirectory from './components/MyWebsiteDirectory.vue';
import CarouselCard from './components/CarouselCard.vue';

import TimeFormatToggle from './components/TimeFormatToggle.vue';

import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import RolesPermissionsToVue from "../../vendor/geowrgetudor/laravel-spatie-permissions-vue/src/js";

import mitt from 'mitt';
const emitter = mitt();

const app = createApp({});

app.use(RolesPermissionsToVue);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);

app.config.globalProperties.emitter = emitter;

app.config.globalProperties.$filters = {
    formatTime(value) {
        if (value) {
            return value.substring(0, 5);
        }
        return '--:--';
    }
}

app.directive('focus', {
    mounted(el) {
      el.focus()
    }
  })

app.component('clock', Clock)

app.component('employee', Employee)
app.component('employee-list', EmployeeList)
app.component('automatic-stamps', AutomaticStamps)

app.component('timekeeping-status', TimekeepingStatus)
app.component('stamp-table', StampTable)

app.component('employee-stamps', EmployeeStamps)

// import ShiftPlan from './components/ShiftPlan';
// import ShiftPlanLine from './components/ShiftPlanLine';

// app.component('shift-plan', ShiftPlan)
// app.component('shift-plan-line', ShiftPlanLine)

app.component('shift-plan', defineAsyncComponent(() =>
    import('./components/ShiftPlan.vue')
))
app.component('shift-plan-line', defineAsyncComponent(() =>
    import('./components/ShiftPlanLine.vue')
))

app.component('project-employees', ProjectEmployees)

app.component('employer-rates', EmployerRates)
app.component('employer-rate-bonuses', EmployerRateBonuses)
app.component('employer-rate-bonus-profiles', EmployerRateBonusProfiles)
app.component('employee-contracts', EmployeeContracts)
app.component('employee-setting-profiles', EmployeeSettingProfiles)
app.component('employee-setting-profiles-button', EmployeeSettingProfilesButton)
app.component('employee-calendar', EmployeeCalendar)
app.component('employee-calendar-day', EmployeeCalendarDay)
app.component('employee-substitution-modal', EmployeeeSubstitutionModal)

app.component('vacation-calendar', VacationCalendar)
app.component('add-absence', AddAbsence)
app.component('edit-absence-button', EditAbsenceButton)
app.component('adjust-flextime', AdjustFlextime)


app.component('change-employee', ChangeEmployee)
app.component('change-employee-inline', ChangeEmployeeInline)
app.component('employee-info', EmployeeInfo)
app.component('employee-sickness-list', EmployeeSicknessList)
app.component('employee-exportlist', EmployeeExportlist)

app.component('qualification-matrix', QualificationMatrix)
app.component('qualification-cell', QualificationCell)

app.component('experience-matrix', ExperienceMatrix)
app.component('experience-cell', ExperienceCell)

app.component('project', Project)
app.component('project-qualifications', ProjectQualifications)
app.component('subproject-projects', SubprojectProjects)
app.component('worktime-alarms', WorktimeAlarms)

app.component('client-budgets', ClientBudgets)

app.component('my-login', MyLogin)
app.component('my-vacation', MyVacation)
app.component('my-vacation-list', MyVacationList)
app.component('my-vacation-year', MyVacationYear)
app.component('my-vacation-year-additional-infos', MyVacationYearAdditionalInfos)
app.component('vacation-request', VacationRequest)
app.component('vacation-confirmation', VacationConfirmation)

app.component('journal-switches', JournalSwitches)

app.component('manual-time-tracking', ManualTimeTracking)
app.component('manual-time-tracking-head', ManualTimeTrackingHead)

app.component('multiselect-costcentre', MultiSelectCostcentre);

app.component('view-all', ViewAll);
app.component('calculation-status', CalculationStatus);

app.component('wagetype-worktype', WagetypeWorktype);

app.component('multiselect-locations', MultiselectLocations);
app.component('multiselect-employers', MultiselectEmployers);
app.component('multiselect-teams', MultiselectTeams);
app.component('multiselect-locations2', MultiselectLocations2);
app.component('singleselect-employees', SingleSelectEmployees);

app.component('dashboard', Dashboard);

app.component('oim-appointmentlist',OimAppointmentsList);
app.component('oim-appointment-resubmission-modal', OimAppointmentResubmissionModal);
app.component('external-times-withoutout',ExternalTimesListWithoutOut);
app.component('external-times-missing',ExternalTimesListMissing);
app.component('reviews',Reviews);
app.component('projects-open',ProjectsOpen);
app.component('vacation-openrequests',VacationOpenRequests);
app.component('expired-qualifications',ExpiredQualifications);
app.component('notifications',Notifications);
app.component('employeevacationmodal', EmployeeVacationModal);
app.component('employeedaysover10hdetails', EmployeeDaysOver10h);
app.component('history', Histroy)
app.component('vacation-history', VacationHistory)

app.component('iframe-modal', IframeModal);
app.component('open-modal-button', OpenModalButton);
app.component('my-website-directory', MyWebsiteDirectory);
app.component('carousel-card', CarouselCard);

app.component('create-single-training-button', CreateSingleTrainingButton);

app.component('time-format-toggle', TimeFormatToggle);

app.component('my-progress-bar',{
	template:
    `<div class="progress border border-dark">
    	<div
    		class="progress-bar progress-bar-striped bg-success"
    		role="progressbar"
    		:style="'width: ' + percent+'%;'"
    		:aria-valuenow="percent"
    		aria-valuemin="0"
    		aria-valuemax="100">
    	</div>
    </div>`,
	props: { percent: {default: 0} }
})


/*app.directive("tooltip", (el, binding) => {
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: "hover",
    });
});*/
import axios from 'axios';

import tooltip from './tooltip'
app.directive('tooltip', tooltip)

import Lang from 'lang.js';
import messages from '../assets/js/ll_messages';
import QualificationsExpired from './components/QualificationsExpired.vue';
import EmployeeExportlist from './components/EmployeeExportlist.vue';



app.config.globalProperties.$trans = new Lang({ messages, locale: 'de', fallback: 'en' });

//axios.get('/js/localization.js').then((response) => {
//    app.config.globalProperties.$trans = new Lang({ messages: response.data.json, locale: 'de', fallback: 'en' });
//});

$(() => {
    app.mount('#app')
})

/*
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/serviceworker.js')
    .then(registration => navigator.serviceWorker.ready)
    .then(registration => registration.sync.register('myFirstSync'));
}
*/
